import React from 'react';
import loader from '../../assets/images/loader.gif';
import Box from '../Layout/Wrappers/Box';
import Typography from '../Layout/Wrappers/Typography';

export default function Loader({
  loading = true,
  text = 'Loading',
  noText = false,
  className,
  style,
  children
}) {
  return loading && (
    noText ? LoadingImage : (
      <Box className={['', className].filter(v => !!v).join(' ')}>
        <Typography className='mr-1'>{(children || text)}</Typography>
        <img src={loader} alt='' className='icon16' />
      </Box>
    )
  );
}

export const LoadingImage = <img src={loader} alt='' className='icon16 s-align-center' />;
